var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-tabs"},_vm._l((_vm.tabs),function(item){return _c('div',{key:item.key,staticClass:"card-tab-item",class:{ active: _vm.activeName === item.key },on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }